import { loginPath, SuccessPath } from 'routes'
import { takeLatest, put } from 'redux-saga/effects'
import { httpGet, httpPost, httpPost1 } from 'core/restClient'
import { createReducer, makeAction, makeKeys } from './reduxHelpers'
import { toastError, toastSuccess, appLoading, appLoaded, toastClear } from 'ducks/app'
import moment from 'moment';

const FORM_COMPLAINT = makeKeys('FORM_COMPLAINT')

export const formComplaint = makeAction(FORM_COMPLAINT.REQUEST, 'data', 'history')


const formComplaintSuccess = makeAction(FORM_COMPLAINT.SUCCESS, 'data')

export function* watchFormComplaintSaga() {
    yield takeLatest(FORM_COMPLAINT.REQUEST, formComplaintRequest)
}

const serviceUrl = process.env.REACT_APP_API_PATH
const apiPath = path => path ? `${serviceUrl}/api/user/v1/form_complaints/${path}` : `${serviceUrl}/api/user/v1/form_complaints`
const multipartHeader = { 'Content-Type': 'multipart/form-data', } //multipart for API upload file

function* formComplaintRequest(action) {
    const { data, history } = action.payload
    try {
        if (data.date_of_incident) {
            // แปลงวันที่ให้เป็นรูปแบบ YYYY/MM/DD
            const formattedDate = moment(data.date_of_incident).format('YYYY/MM/DD');
            // เก็บวันที่ที่แปลงแล้วกลับไปใน data
            data.date_of_incident = formattedDate;
        }
        if (data.sender_first_name) {
            const nameAndLastname = data.sender_first_name + " " + data.sender_last_name;
            data.sender_name = nameAndLastname;
        }
        const response = yield httpPost(apiPath(), data, multipartHeader)
        if (response.status >= 200 && response.status < 300) {
            yield put(appLoaded());
            history(SuccessPath(response.data.data.caseId), { replace: true })
        }
    }
    catch (e) {
        if (localStorage.getItem('language') == "en") {
            yield put(toastError(`Please try again later.`, e.data.DevMsg))
            yield put(appLoaded());
        } else {
            yield put(toastError(`กรณาลองใหม่อีกครั้ง`, e.data.DevMsg))
            yield put(appLoaded());
        }


    }
}





const initial = {


}

export default createReducer(initial, state => ({
}))